import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const DynamicIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 16 16"
         fill="none"
         {...props}
      >
         <path
            d="M1.5 1.4541C1.5 1.03848 1.16562 0.704102 0.75 0.704102C0.334375 0.704102 0 1.03848 0 1.4541L0 12.4541C0 13.6979 1.00625 14.7041 2.25 14.7041L15.25 14.7041C15.6656 14.7041 16 14.3697 16 13.9541C16 13.5385 15.6656 13.2041 15.25 13.2041L2.25 13.2041C1.83438 13.2041 1.5 12.8697 1.5 12.4541L1.5 1.4541ZM10 4.4541C10 4.86973 10.3344 5.2041 10.75 5.2041L12.4406 5.2041L9.5 8.14473L7.03125 5.67598C6.7375 5.38223 6.2625 5.38223 5.97188 5.67598L3.47187 8.17598C3.17812 8.46973 3.17812 8.94473 3.47187 9.23535C3.76562 9.52598 4.24062 9.5291 4.53125 9.23535L6.5 7.2666L8.96875 9.73535C9.2625 10.0291 9.7375 10.0291 10.0281 9.73535L13.4969 6.2666L13.4969 7.9541C13.4969 8.36973 13.8313 8.7041 14.2469 8.7041C14.6625 8.7041 14.9969 8.36973 14.9969 7.9541L14.9969 4.4541C14.9969 4.03848 14.6625 3.7041 14.2469 3.7041L10.75 3.7041C10.3344 3.7041 10 4.03848 10 4.4541Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default DynamicIcon
